import React from "react";
import { Calculation } from "../../../../../../src/application/Contracts";
import ProductCatalogLegendModal from "../../ProductCatalogLegendModal";
import formModelStore from "../../../../../store/FormModelStore";
import { FieldProps } from "../../../../common/Interfaces";


interface SelfState {
    value: any | number[],
    modalIsOpened: boolean
    additionalModel: any,
    filterItems: string
}

interface SelfProps {
    additionalModel: any,
    readonly?: boolean
}


export class TwsProductCatalogSelectProduct extends React.Component<FieldProps & SelfProps, SelfState> {
    constructor(props: any) {
        super(props);
        this.state = {
            value: this.props.value,
            additionalModel: this.props.additionalModel,
            modalIsOpened: false,
            filterItems: ""
        }
    }

    renderCardLegendButton = () => {
        return <div className={`card-legend-button`} onClick={() => this.setState({ modalIsOpened: true })}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                    stroke="#4D5E80" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.375 9.375H10V13.75H10.625" stroke="#4D5E80" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9.84375 7.5C10.3615 7.5 10.7812 7.08027 10.7812 6.5625C10.7812 6.04473 10.3615 5.625 9.84375 5.625C9.32598 5.625 8.90625 6.04473 8.90625 6.5625C8.90625 7.08027 9.32598 7.5 9.84375 7.5Z"
                    fill="#4D5E80" />
            </svg>
            <div>{__("Card Legend")}</div>
        </div>
    }

    getFilteredList = () => {
        if (this.state.filterItems.length < 0) {
            return this.state.additionalModel.items;
        }
        return this.state.additionalModel.items.filter((z: Calculation.ProductCatalogItemModel) => z.name.toLowerCase().indexOf(this.state.filterItems.toLowerCase()) > -1);
    }


    render() {
        return <React.Fragment>
            <ProductCatalogLegendModal isOpen={this.state.modalIsOpened}
                onCloseClick={() => this.setState({ modalIsOpened: false })} />
            <div className={`tws-product-catalog-select-product`}>
                <div className={`header`}>
                    <div className={`filter-input`}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.15625 14.0625C11.4182 14.0625 14.0625 11.4182 14.0625 8.15625C14.0625 4.89432 11.4182 2.25 8.15625 2.25C4.89432 2.25 2.25 4.89432 2.25 8.15625C2.25 11.4182 4.89432 14.0625 8.15625 14.0625Z"
                                stroke="#9E9E9E" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.332 12.332L15.7492 15.7492" stroke="#9E9E9E" strokeLinecap="round"
                                strokeLinejoin="round" />
                        </svg>
                        <input onChange={(event) => {
                            this.setState({ filterItems: event.target.value })
                        }} type={"text"}
                            placeholder={__("Search by article number")} />
                    </div>
                    {this.renderCardLegendButton()}
                </div>
                <div className={`body`}>
                    {this.getFilteredList().map(this.renderItem)}
                </div>
            </div>
        </React.Fragment>
    }

    public static renderInformationSection = (item: Calculation.ProductCatalogItemModel) => {
        if (!item) {
            return <></>
        }
        let maxPowerText = "";
        if (item.maxPower) {
            maxPowerText = __(`Up to `) + item.maxPower + " kW"
        }
        return <div className={`information`}>
            {maxPowerText}
            <div className={`icons`}>
                {item.direct && <div>
                    <div className={`direct-icon`} />
                </div>}
                {item.inDirect && <div>
                    <div className={`indirect-icon`} />
                </div>}
                {item.plateAndGasketsHeatExchanger && <div className={`plate-and-gaskets`} />}
                {item.fusionBondedHeatExchanger && <div className={`fusion-bonded`} />}
                {item.copperBrazedHeatExchanger && <div className={`copper-brazed`} />}
            </div>
        </div>
    }

    selectedItem = (name: string) => {
        return formModelStore.formModel?.inputMethod?.productCatalogCalculation?.selectedProduct?.value?.name === name;
    }
    private renderItem = (item: Calculation.ProductCatalogItemModel) => {
        return <div className={`tws-product-family ${this.selectedItem(item.name) ? 'active' : ''}`}
            onClick={() => this.productSelect(item)}
            key={item.name}>
            <div className={`description`}>
                <div className={`name`}>
                    {item.displayName}
                    <div className={`title`}>
                        {__(item.title)}
                    </div>
                </div>
                {TwsProductCatalogSelectProduct.renderInformationSection(item)}
            </div>
            {item.image && <div className={`image`} style={{ backgroundImage: `url(${item.image})` }} />}
        </div>
    }

    productSelect = (item: Calculation.ProductCatalogItemModel) => {
        this.props.onChange(item)
        this.props.additionalModel.onProductSelect(item);
    }
}